module.exports = __webpack_public_path__ + "static/media/tnc-active.c56f46eb.svg";